module.exports = __webpack_public_path__ + "img/event.903f2e65.png";